<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template functional>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <p>
      <!-- コピーライト 発行した日 -->
      <span>&copy; 2020 <a href="https://aidea.biz/" target="_blank" rel="nofollow">Aidea.inc</a></span>
    </p>
    <span class="md:flex items-center">
      <!-- バージョン情報-->
      <span>Version {{ props.version }} </span>
      <span v-if="!props.isProduction">({{ props.environment }})</span>
    </span>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String
    },
    version: {
      type: String,
      required: true
    },
    environment: {
      type: String,
      required: true
    },
    isProduction: {
      type: Boolean,
      required: true
    },
  },
};
</script>
